import router from './router'
import { startApp } from '../../bootstrap/startApp'

startApp({ router })
